// extracted by mini-css-extract-plugin
export var container = "Desktop-module--container--e7b01";
export var desktopWidgetWrapper = "Desktop-module--desktopWidgetWrapper--6eb50";
export var heading = "Desktop-module--heading--3191d";
export var modalWrapper = "Desktop-module--modalWrapper--d2c01";